import React from 'react';
import {Table as BaseTable} from 'desktop/sports/mlb/players-list/showdown';

class Table extends BaseTable {}

export {Table};
